<template>
  <accounts-component-template
    :component-name="'Account Users (' + (users ? users.length : 0) + ')'"
    component-key="acclaro-users"
    color="#4B95C3"
    :has-search="false">
      <template v-slot:icon>
        <account-group-outline-icon :size="16"/>
      </template>
      <template v-slot:content>
          <section class="accounts-details-users">
              <div class="accounts-users-table-wrap">
                  <table class="accounts-users-table">
                      <thead class="accounts-users-table-head">
                      <tr>
                          <th
                            class="accounts-users-table-header"
                            :class="{'th-center': column == 'My Acclaro'}"
                            title
                            v-for="column in columnHeaders">
                              <span>
                                <span v-html="column"></span>
                                <i @click="getInfoPage()" id="connectors-help-icon" v-if="column == 'Role'" class="acclaro-icon ai-info clickable"></i>
                              </span>
                          </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr class="accounts-users-table-row" v-for="user in compUsers" :key="user.id">
                          <td>
                              <div v-if="user.plunetid" class="account-users-name">
                                  <a  v-if="!userPortalDisabled(user)" target="_blank" :href="plunetLink + user.plunetid"><span v-text="user.lastname + ', ' + user.firstname"></span></a>
                              </div>
                              <div v-else class="account-users-name no-link" v-text="user.firstname + ' ' + user.lastname"></div>
                              <span class="not-in-plunet" v-if="userPortalDisabled(user)">Not In Plunet</span>
                          </td>
                          <td>
                              <div style="min-width:71px;" class="align-text-center">
                                  <input @change="toggleUserAcclaroPortal(user)" v-model="user.portalenable" type="checkbox">
<!--                                  <span v-if="user.portalenable">Enabled</span>-->
<!--                                  <span v-else>Disabled</span>-->
                              </div>
                          </td>
                          <td>
                              <div v-if="roles.customer_role_data">
                              <multiselect
                                @input="(event) => setUserRole(user, event)"
                                track-by="key"
                                label="name"
                                class="account-users-multiselect role-multiselect"
                                :value="{name: findUserRoleByKey(user), key: user.role}"
                                :options="getUserRoles(user)"
                                :disabled="!user.portalenable || userPortalDisabled(user)"
                                :multiple="false"
                                :taggable="false"
                                :allow-empty="false"
                                :select-label="' '"
                                :selected-label="' '"
                                placeholder="Select role"
                                :deselect-label="' '">
                                <span slot="noResult">No results found</span>
                                <template slot="caret" slot-scope="{toggle}" :toggle="toggle">
                                    <chevron-down-icon title="roles" :size="24" @mousedown.prevent.stop="toggle()" class="multiselect__select" />
                                </template>
                              </multiselect>
                            </div>
                          </td>
                          <td>
                              <div class="account-users-password-col">
                                  <!-- <select @change="onSetPasswordState(user)" v-model="user.passwdstate">
                                    <option value="activated">Activated</option>
                                    <option value="reset">Reset</option>
                                </select> -->
                                <multiselect
                                  class="account-users-multiselect password-multiselect"
                                  @input="(input) => onSetPasswordState(user, input)"
                                  :value="user.passwdstate"
                                  :options="['activated', 'reset']"
                                  :custom-label="getPasswordLabel"
                                  :multiple="false"
                                  :taggable="false"
                                  :allow-empty="false"
                                  :option-height="20"
                                  :select-label="' '"
                                  :selected-label="' '"
                                  placeholder=""
                                  :deselect-label="' '">
                                  <span slot="noResult">No results found</span>
                                  <template slot="caret" slot-scope="{toggle}" :toggle="toggle">
                                      <chevron-down-icon title="password state" :size="24" @mousedown.prevent.stop="toggle()" class="multiselect__select" />
                                  </template>
                                </multiselect>

                                <div v-if="user.passwdstate == 'reset'">
                                    <button @click="inviteUser(user)" class="invite-user-btn">Invite</button>
                                </div>
                              </div>
                          </td>
                          <td>
                              <button v-if="user.portalenable" class="become-user-btn" @click="showImpersonationDialog(user)" type="button">Become User</button>
                          </td>
                      </tr>
                      </tbody>
                  </table>
              </div>
              <notifications group="foo" />
          </section>
      </template>
  </accounts-component-template>
</template>

<script>
import AccountsComponentTemplate from './AccountsComponentTemplate.vue';
import {AccountGroupOutlineIcon, ChevronDownIcon} from '../icons';
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import {isNil, map} from 'lodash';
import Vue from 'vue';

const ACCOUNT_USER_BASE_URL = '/admin/menuclick';

const successNotification = (title, message) => {
    Vue.notify({
        group: 'admin:account:details',
        title: title,
        text: message,
        type: 'success',
        duration: 3000,
        speed: 500
    });
};

function failureNotification (title, message) {
    Vue.notify({
        group: 'admin:account:details',
        title: title,
        text: message,
        type: 'error',
        duration: 3000,
        speed: 500
    });
}

export default {

  props: {

  },

  components: {
    AccountsComponentTemplate,
    AccountGroupOutlineIcon,
    ChevronDownIcon,
  },

  data () {
    return {
        //localUsers: [...this.users]
        //@TODO - get correct plunet link
        plunetLink: 'https://plunetqa1.acclaro.com/pagesUTF8/partner_kunde.jsp?OSGO1=0#AP',
        infoBubble: {},
        roles: {},
        columnHeaders: [
            'Name',
            'My Acclaro',
            'Role',
            'Password',
            '',
        ]
    }
  },

  updated () {},

  beforeMount () {
    this.getRoles().then(roles => {
      this.roles = roles
    });
  },

  computed: {

      ...mapGetters('AdminAccountDetailsStore', [
          'users',
          'accountId'
      ]),

      compUsers () {

        try {
          return this.users.map(user => user )
          .sort((a, b) => (a.lastname ?? '').localeCompare((b.lastname ?? '')))
        } catch (e) {
          console.error('AccountUsers:error', e.message);
          return [];
        }
      },
  },

  methods: {
      ...mapActions('AdminAccountDetailsStore', [
          'sendInvite',
          'updateAccountUserRole',
          'setPasswordState'
      ]),

      getPasswordLabel (item) {
        function capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        }

        return capitalizeFirstLetter(item);
      },

      findUserRoleByKey (user) {
        const isInternal = this.userIsInternal(user);
        const { customer_role_data, internal_role_data } = this.roles;
        let userRoleName = null;

        const getRoleName = (role_set) => {
          let roleName = null;
          const role = role_set[user.role];

          return role?.name;
        };

        try {
          if (isInternal) {
            userRoleName = getRoleName(internal_role_data)
          } else {
            userRoleName = getRoleName(customer_role_data)
          }

          return userRoleName;

        } catch ($e) {
          console.error('failed to get user role by key:', $e.message);
          return null;
        }
      },

      getInfoPage () {
        showPopupPage('rolehelp', 'User Roles', 700);
      },

      onSetPasswordState (user, passwdstate) {
        this.setPasswordState({user, passwdstate});
      },

      showImpersonationDialog (user) {
          this.$emit('impersonate-modal', {user});
      },

      showInviteDialog (result, user) {
          this.$modal.show('dialog', {
              title: `
                <div class="account-users-invite-header">
                  <span>Invite</span>
                  <span id="invite-modal-close" class="clickable">X</span>
                </div>
              `,

              //we are removing the 'or send email invitation' function
              //from returned html.
              //@TODO - replace the legacy code here
              text: result.data.split('Or ')[0],
              buttons: [
                  {
                      title: 'Send Email Invitation',
                      class: 'vue-dialog-button reviewer-dialog-btn close-btn',
                      handler: () => {
                          this.sendInvite(user).then(result => {
                              if(result.includes('Sent')) {
                                  this.showSuccesfulInvite();
                                  this.$modal.hide('dialog');
                              }
                          })
                      }
                  }
              ]
          });


          setTimeout(() => {
            $('#invite-modal-close').one('click', () => {
              this.$modal.hide('dialog');
            })
          }, 1000);
      },

      userPortalDisabled (user) {
          const {plunetid, plunet_status, portalenable} = user;
          const plunetInactive = !isNil(plunetid) && plunet_status !== 1;

          let result = plunetInactive || isNil(plunetid) || isNil(portalenable);

          return result;
      },

      userIsInternal (user) {
        try {
          const allowedDomains = ["@acclaro.com", "@jonckers.com"];
          const email = user.email.toLowerCase();

          return allowedDomains.some(domain => email.endsWith(domain));
        } catch (e) {
          console.error(e.message)
          return false
        }
      },

      getUserRoles (user) {
          let roles = this.userIsInternal(user) ? this.roles.internal_role_data : this.roles.customer_role_data;

          return map(roles, (val, key) => {
              return {
                  name: roles[key]['name'],
                  key: key
              }
          });
      },

      setUserRole(user, selected) {
        const {name, key} = selected;
        let userId = user.id;

        let payload = {
          rolename: name,
          role: key,
          userId
        };

        this.updateAccountUserRole(payload).then(result => {
          //console.log('udpate account user role result', result);
        })
      },

      setUserRoleLegacy(user, $event) {
          let roleOptions = $event.target.options;
          let selectedOptionName = roleOptions[$event.target.selectedIndex].textContent;

          let rolename = selectedOptionName
          let userId = user.id;
          let role = $event.target.value;

          let payload = {
            rolename,
            role,
            userId
          };

          this.updateAccountUserRole(payload).then(result => {
            //console.log('udpate account user role result', result);
          })
      },

      getRoles () {
        return axios.get('/admin/account/user-roles').then(result => result.data);
      },

      inviteUser (user) {
          let params = {
              u: `aapdw${user.id}`
          };

          return axios.get('/admin/view-invite', {params}).then(result => {
              this.showInviteDialog(result, user);
          });
      },

      showSuccesfulInvite () {
          this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Your invite has been sent',
              text: `Invite sent successfully!`,
              duration: 1000,
              speed: 1000,
              animation: {
                  enter: { height: 200, opacity: 1, top: '10%', left: '10%' },
                  leave: { height: 0, opacity: 0, top: '10%', left: '10%'}
              },
              data: {}
          })
      },

      toggleUserAcclaroPortal (user) {
          let userId = user.id;
          let activeState = user.portalenable ? 'Enabled' : 'Disabled';

          return axios.get(ACCOUNT_USER_BASE_URL, {
              params: {
                  t: `aapdp${userId}dd`,
                  v: activeState
              }
          }).then(result => {
              if(result.data) {
                  console.error('Account User Error: failed to update user portal access');
              }

              successNotification('', `My Acclaro ${activeState.toLowerCase()}`)
          })
      },
  }
}
</script>
